module.exports = __webpack_public_path__ + "static/img/greetings.5148cdc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/greetings.jpg
// module id = lwMB
// module chunks = 1